export const chemoTranslations = {
    status: {
        approved: 'מאושר',
        rejected: 'נדחה',
        pending: 'ממתין',
        completed: 'הושלם',
        draft: 'טיוטה',
        inProgress: 'בתהליך'
    },

    errors: {
        noRecordsFound: 'לא נמצאו רשומות מתאימות',
        loadingError: 'שגיאה בטעינת הנתונים. אנא נסה שוב.',
        saveError: 'שגיאה בשמירת הדוח. אנא נסה שוב.',
        patientError: 'במטופל ',
        dateRangeRequired: 'נא למלא תאריך התחלה ותאריך סיום',
        errorOccurred: 'אירעה שגיאה',
        errorPrefix: 'שגיאה: ',
        submitError: 'שגיאה בשליחת הדוח',
        messageSendError: 'שגיאה בשליחת ההודעה. אנא נסה שוב.'
    },

    success: {
        reportSaved: 'הדוח נשמר בהצלחה',
        messageSent: 'ההודעה נשלחה בהצלחה'
    },

    labels: {
        records: 'רשומות',
        unknownCreator: 'לא ידוע',
        patient: 'מטופל',
        medication: 'תרופה',
        date: 'תאריך',
        dosage: 'מינון',
        approve: 'אשר',
        reject: 'דחה',
        selected: 'נבחרו',
        approveSelected: 'אשר נבחרות',
        rejectSelected: 'דחה נבחרות',
        clearSelection: 'נקה בחירה',
        chemoReports: 'דוחות כימותרפיה',
        chemoManagement: 'ניהול ומעקב אחר טיפולי כימותרפיה',
        newReport: 'דוח חדש',
        noRecordsFound: 'לא נמצאו רשומות',
        tryChangingFilters: 'נסה לשנות את החיפוש או הפילטרים שלך',
        treatmentRecords: 'רשומות טיפול',
        noReportsAvailable: 'אין דוחות זמינים',
        reportsWillAppear: 'הדוחות יוצגו כאן לאחר יצירתם. לחץ על "דוח חדש" כדי להתחיל',
        reportNumber: 'מספר דוח',
        createdBy: 'נוצר על ידי',
        numRecords: 'מספר רשומות',
        actions: 'פעולות',
        viewReport: 'צפייה בדוח',
        requiredField: '* שדה חובה',
        cancel: 'ביטול'
    },

    form: {
        viewReport: 'צפייה בדוח',
        currentChemoReport: 'דוח כימותרפיה נוכחי',
        reportParams: 'פרמטרי דוח',
        searchReport: 'חפש דוח',
        startDate: 'תאריך התחלה',
        endDate: 'תאריך סיום',
        hospital: 'בית חולים',
        loadingData: 'טוען נתונים...',
        loadingFromHospital: 'טוען נתונים מבית החולים...',
        pleaseWait: 'אנא המתן בזמן שאנו טוענים את המידע',
        noDataToDisplay: 'אין נתונים להצגה',
        useFormToSearch: 'השתמש בטופס למעלה כדי לחפש רשומות טיפול',
        saveReport: 'שמור דוח',
        treatmentRecords: 'רשומות טיפול',
        chemoRecordsPrefix: 'רשומות כימו - ',
        numRecordsLabel: 'מספר רשומות',
        dateRangeSearch: 'חיפוש דוחות לפי טווח תאריכים',
        search: 'חפש'
    },

    table: {
        row: 'שורה',
        deliveryDate: 'תאריך אספקה',
        day: 'יום',
        districtDescription: 'תיאור מחוז מרכז',
        description: 'תיאור',
        customerNumber: 'מספר לקוח',
        customerName: 'שם לקוח',
        willArrive: 'יגיע',
        willNotArrive: 'לא יגיע',
        endTreatment: 'סיום טיפול',
        updateDate: 'עדכון תאריך',
        order: 'הזמנה',
        remainingDoses: 'יתרת מנות',
        lastDate: 'תאריך אחרון',
        updateDeliveryDate: 'עדכון תאריך אספקה',
        loaded: 'טעון',
        status: 'סטטוס',
        markWillArrive: 'סמן יגיע',
        markWillNotArrive: 'סמן לא יגיע',
        markEndTreatment: 'סמן סיום טיפול',
        updateDateTooltip: 'עדכן תאריך',
        messageToService: 'הודעה לשירות לקוחות',
        messagePlaceholder: 'הקלד הודעה...'
    },

    warnings: {
        unchangedRecordsTitle: 'אזהרה - רשומות ללא שינוי',
        oneUnchangedRecord: 'קיימת רשומה אחת שלא עברה שינוי:',
        multipleUnchangedRecords: 'קיימות {count} רשומות שלא עברו שינוי:',
        selectOptionForEachRecord: 'יש לבחור עבור כל רשומה: "יגיע", "לא יגיע" או "סיום טיפול".',
        backToEdit: 'חזור לעריכה',
        saveAnyway: 'שמור בכל זאת',
        differentDatesTitle: 'שים לב - תאריכי אספקה שונים',
        differentDatesMessage: 'הדוח מכיל תאריכי אספקה שונים. נא בדוק אם ניתן לעדכן את כל המטופלים לאותו תאריך.',
        deliveryDatesFound: 'תאריכי אספקה שנמצאו:',
        recommendSameDate: 'רצוי לוודא שכל המטופלים מעודכנים לאותו תאריך אספקה.',
        continueAnyway: 'המשך בכל זאת'
    },

    lock: {
        recordLoaded: 'הרשומה נטענה ואינה ניתנת לשינוי',
        dateOutOfRange: 'תאריך אספקה לא בטווח'
    },

    settings: {
        title: 'הגדרות כימותרפיה',
        description: 'כאן יופיעו ההגדרות והתצורות של מערכת ניהול הכימותרפיה',
        placeholder: 'ההגדרות יתווספו בקרוב'
    },

    dialog: {
        approveTitle: 'אישור רשומה',
        rejectTitle: 'דחיית רשומה',
        editTitle: 'עריכת רשומה',
        notesLabel: 'הערות',
        rejectReasonLabel: 'סיבת דחייה',
        editDetailsLabel: 'פרטים לעריכה',
        approve: 'אשר',
        reject: 'דחה',
        save: 'שמור',
        close: 'סגור',
        saveWithErrors: 'שמירה הושלמה עם שגיאות',
        savedSuccessfully: 'הדוח נשמר בהצלחה',
        recordsUpdatedSuccess: 'רשומות עודכנו בהצלחה',
        recordsFailed: 'רשומות נכשלו',
        successfulRecords: 'רשומות שעודכנו בהצלחה:',
        failedRecords: 'רשומות שנכשלו:',
        rowPrefix: 'שורה'
    },

    message: {
        titlePrefix: 'הודעה מבית חולים ',
        writeMessage: 'כתוב את ההודעה שברצונך לשלוח לשירות הלקוחות',
        placeholder: 'הקלד את ההודעה כאן...',
        sending: 'שולח...',
        send: 'שלח הודעה'
    }
};

export const CHEMO_DEFAULTS = {
    TOP_RECORDS: 8,
    DAYS_AHEAD: 10,
    TREATMENT_TYPE: '3',
    PRODUCT_CODE: 'Z-0026'
};
